import { Box, Typography } from "@mui/material";
import LogoIcon from "../../../assets/images/logo-icon.png";
import { FC } from "react";

interface MycomponentProps {
  message: string;
  incomingTextColor: any;
}

const PlayGroundInitialMessage: FC<MycomponentProps> = (props) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          mb: 3,
        }}
      >
        <Box>
          <Box sx={{ display: "flex" }}>
            {/* <Box
              sx={{
                display: "flex",
                mr: 2,
                height: "24px",
              }}
            >
              <img
                src={LogoIcon}
                alt="Company Logo"
                style={{ width: 24, height: "auto" }}
              />
            </Box> */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {/* Main Text */}
              <Typography variant="h5"sx={{color:props.incomingTextColor}}>{props.message || "..."}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default PlayGroundInitialMessage;
